import React, { useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { DynamicForm } from "@shared/components/DynamicForm";
import { FormField } from "@shared/services/FormServices";
import { useBillDraftStatus } from "@features/bx/singleBillGenaration/hooks";
import { BUTTON_FIELD_CLASSES, FIELD_CLASSES } from "@shared/utils/constants";

interface SingleBillFilterProps {
  form: UseFormReturn<any>;
  onApply: (data: any) => void;
  onReset: () => void;
}

export const SingleBillFilter: React.FC<SingleBillFilterProps> = ({
  form,
  onApply,
  onReset,
}) => {
  const { data: statusData } = useBillDraftStatus();

  const statusOptions = useMemo(() => {
    return (
      statusData?.map((status: any) => ({
        label: status.value,
        value: status.key,
      })) || []
    );
  }, [statusData]);

  const fields: FormField[] = [
    {
      name: "status",
      label: "Status",
      type: "select",
      placeholder: "Select Status",
      options: statusOptions,
      className: "col-span-1",
    },
  ];

  const handleReset = () => {
    form.reset({
      status: "",
    });
    onReset();
  };

  return (
    <div className="space-y-4">
      <DynamicForm
        fields={fields}
        form={form}
        gridColumns={3}
        responsiveColumns={{ sm: 1, md: 2, lg: 2 }}
        onSubmit={onApply}
        onReset={handleReset}
        config={{
          classes: BUTTON_FIELD_CLASSES,
          submitButtonText: "Apply Filters",
          resetButtonText: "Reset",
          showResetButton: true,
        }}
      />
    </div>
  );
};
